// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* LiveFormPreview.css */
/* Disable all transitions for grid items */
.react-grid-item {
  transition: none !important;
  will-change: transform; /* Optimize for transforms */
}
body{
  overflow-x: hidden;
}
.layout {
  /* height: fit-content !important; */
  min-height: fit-content !important;
}

/* Parent container styles */
.preview-container {
  overflow: visible !important;
}

.react-grid-layout {
  position: relative;
  transition: height 200ms ease !important; /* Faster transition */
  background: transparent !important;
}

/* Lock the select container in place during interactions */
.select-container {
  position: relative;
  z-index: auto;
  transform: translateZ(0); /* Create a new stacking context */
}

/* Boost z-index only when select is focused */
.select-container select:focus {
  z-index: 1000;
  position: relative;
}

/* Prevent any layout shifts */
.react-grid-item {
  contain: layout;
}

/* Fix for the dropdown arrow */
/* .react-grid-item .absolute
 {
    position: absolute;
    z-index: 1;
    top: -15px;
    right: 0;
} */

.text-editor-toolbar {
  display: flex;
  gap: 4px;
  padding: 4px;
  background: #f0f0f0;
  border: 1px solid #ddd;
  border-bottom: none;
}

.text-editor-content {
  min-height: 50px;
  padding: 8px;
  border: 1px solid #ddd;
  outline: none;
}

.text-editor-content:focus {
  border-color: #4d90fe;
}

.text-editor-button {
  padding: 4px 8px;
  background: white;
  border: 1px solid #ccc;
  border-radius: 3px;
  cursor: pointer;
}

.text-editor-button:hover {
  background: #e6e6e6;
}

/* .react-grid-item{
  height: fit-content !important;
} */

.gap-8.gap-custum {
    gap: 10rem
;
}
.gap-custum select
 {
    min-width: 223px;
    padding: 7px !important;
}
.relative .absolute button.bg-red-600
 {
    width: 5px !important;
    height: 5px !important;
    padding: 6px;
}

.relative button.text-xs.text-blue-500.underline.mb-2
 {
    position: absolute;
    right: 18px;
    top: -10px;}

.custum-grid .space-y-4 {
    width: 80%;
}    
.custum-grid {
    display: flex
;
}
.selected-field
 {
    position: relative;
}
.delete-filed
 {
    position: absolute;
    top: -9px;
    width: 5px;
    height: 5px;
    padding: 6px;
}
.buttoncross {
    position: absolute;
    right: 9px;
    width: 5px;
    height: 5px;
    padding: 6px;
}
.absolute1 button {
    width: 5px;
    height: 5px;
    padding: 6px;
}
.absolute1 {
    position: absolute;
    right: 0;
    top: 0;
}
.relative1 .underline
 {
    position: absolute;
    right: 22px;
    top: 6px;
}`, "",{"version":3,"sources":["webpack://./src/pages/hr_forms_manager/hiring/LiveFormPreview.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB,2CAA2C;AAC3C;EACE,2BAA2B;EAC3B,sBAAsB,EAAE,4BAA4B;AACtD;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA,4BAA4B;AAC5B;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,wCAAwC,EAAE,sBAAsB;EAChE,kCAAkC;AACpC;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,aAAa;EACb,wBAAwB,EAAE,kCAAkC;AAC9D;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;;;;;;GAMG;;AAEH;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;GAEG;;AAEH;IACI;AACJ;AACA;AACA;;IAEI,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;;IAEI,qBAAqB;IACrB,sBAAsB;IACtB,YAAY;AAChB;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX,UAAU,CAAC;;AAEf;IACI,UAAU;AACd;AACA;IACI;AACJ;AACA;AACA;;IAEI,kBAAkB;AACtB;AACA;;IAEI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,WAAW;IACX,YAAY;AAChB;AACA;IACI,UAAU;IACV,WAAW;IACX,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,MAAM;AACV;AACA;;IAEI,kBAAkB;IAClB,WAAW;IACX,QAAQ;AACZ","sourcesContent":["/* LiveFormPreview.css */\r\n/* Disable all transitions for grid items */\r\n.react-grid-item {\r\n  transition: none !important;\r\n  will-change: transform; /* Optimize for transforms */\r\n}\r\nbody{\r\n  overflow-x: hidden;\r\n}\r\n.layout {\r\n  /* height: fit-content !important; */\r\n  min-height: fit-content !important;\r\n}\r\n\r\n/* Parent container styles */\r\n.preview-container {\r\n  overflow: visible !important;\r\n}\r\n\r\n.react-grid-layout {\r\n  position: relative;\r\n  transition: height 200ms ease !important; /* Faster transition */\r\n  background: transparent !important;\r\n}\r\n\r\n/* Lock the select container in place during interactions */\r\n.select-container {\r\n  position: relative;\r\n  z-index: auto;\r\n  transform: translateZ(0); /* Create a new stacking context */\r\n}\r\n\r\n/* Boost z-index only when select is focused */\r\n.select-container select:focus {\r\n  z-index: 1000;\r\n  position: relative;\r\n}\r\n\r\n/* Prevent any layout shifts */\r\n.react-grid-item {\r\n  contain: layout;\r\n}\r\n\r\n/* Fix for the dropdown arrow */\r\n/* .react-grid-item .absolute\r\n {\r\n    position: absolute;\r\n    z-index: 1;\r\n    top: -15px;\r\n    right: 0;\r\n} */\r\n\r\n.text-editor-toolbar {\r\n  display: flex;\r\n  gap: 4px;\r\n  padding: 4px;\r\n  background: #f0f0f0;\r\n  border: 1px solid #ddd;\r\n  border-bottom: none;\r\n}\r\n\r\n.text-editor-content {\r\n  min-height: 50px;\r\n  padding: 8px;\r\n  border: 1px solid #ddd;\r\n  outline: none;\r\n}\r\n\r\n.text-editor-content:focus {\r\n  border-color: #4d90fe;\r\n}\r\n\r\n.text-editor-button {\r\n  padding: 4px 8px;\r\n  background: white;\r\n  border: 1px solid #ccc;\r\n  border-radius: 3px;\r\n  cursor: pointer;\r\n}\r\n\r\n.text-editor-button:hover {\r\n  background: #e6e6e6;\r\n}\r\n\r\n/* .react-grid-item{\r\n  height: fit-content !important;\r\n} */\r\n\r\n.gap-8.gap-custum {\r\n    gap: 10rem\r\n;\r\n}\r\n.gap-custum select\r\n {\r\n    min-width: 223px;\r\n    padding: 7px !important;\r\n}\r\n.relative .absolute button.bg-red-600\r\n {\r\n    width: 5px !important;\r\n    height: 5px !important;\r\n    padding: 6px;\r\n}\r\n\r\n.relative button.text-xs.text-blue-500.underline.mb-2\r\n {\r\n    position: absolute;\r\n    right: 18px;\r\n    top: -10px;}\r\n\r\n.custum-grid .space-y-4 {\r\n    width: 80%;\r\n}    \r\n.custum-grid {\r\n    display: flex\r\n;\r\n}\r\n.selected-field\r\n {\r\n    position: relative;\r\n}\r\n.delete-filed\r\n {\r\n    position: absolute;\r\n    top: -9px;\r\n    width: 5px;\r\n    height: 5px;\r\n    padding: 6px;\r\n}\r\n.buttoncross {\r\n    position: absolute;\r\n    right: 9px;\r\n    width: 5px;\r\n    height: 5px;\r\n    padding: 6px;\r\n}\r\n.absolute1 button {\r\n    width: 5px;\r\n    height: 5px;\r\n    padding: 6px;\r\n}\r\n.absolute1 {\r\n    position: absolute;\r\n    right: 0;\r\n    top: 0;\r\n}\r\n.relative1 .underline\r\n {\r\n    position: absolute;\r\n    right: 22px;\r\n    top: 6px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
